import { css } from '@emotion/react'
import { Stepper, StepperProps } from 'bold-ui'
import { useMemo } from 'react'

interface VerticalStepperProps extends StepperProps {
  gap?: number
}

export function VerticalStepper(props: Readonly<VerticalStepperProps>) {
  const { gap = 0, style, ...rest } = props

  const styles = useMemo(() => createStyles(gap), [gap])

  return <Stepper direction='vertical' style={css(styles.verticalStepper, style)} {...rest} />
}

const createStyles = (gap: number) => ({
  verticalStepper: css`
    height: auto;
    flex-direction: column;
    & > * {
      &:not(:last-child) {
        padding-bottom: ${gap}rem;
      }
    }
  `,
})
